import { useContext, useEffect } from "react";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { DESKTOP_DRAWER } from "components/TutorialMode/constants";
import RoutesContext from "context/routes/routesContext";
import TutorialContext from "context/tutorial/tutorialContext";
import { DESKTOP_DRAWER_OPEN, useMediaQueries } from "shared";

import { STEP_GROUP } from "../../TutorialMode/types/enums";
import Navigation from "../Navigation";
import ToggleDrawerButton from "./ToggleDrawerButton/ToggleDrawerButton";
import { DesktopDrawerProps } from "./types";

const DesktopDrawer = ({ bannerHeight }: DesktopDrawerProps) => {
    const { blue700, gray50, gray200 } = colors;

    const { to1099 } = useMediaQueries();

    const { stepGroup, stepIndex } = useContext(TutorialContext);

    const { isDesktopDrawerOpen, setDesktopDrawerStatus } =
        useContext(RoutesContext);

    useEffect(() => {
        to1099 && handleDrawerStatus(false);
        // eslint-disable-next-line
    }, [to1099]);

    const handleDrawerStatus = (isOpen: boolean) => {
        setDesktopDrawerStatus(isOpen);
        localStorage.setItem(DESKTOP_DRAWER_OPEN, `${isOpen}`);
    };

    const isTaskGroupsTutorialActive =
        stepGroup === STEP_GROUP.TutorialTaskGroups && stepIndex === 0;

    const HEADER_HEIGHT = 56;

    return (
        <aside
            id={DESKTOP_DRAWER}
            css={css({
                position: "fixed",
                top: `${bannerHeight + HEADER_HEIGHT}px`,
                bottom: "0",
                zIndex: "1200",
                background: gray50,
                borderRight: `1px solid ${gray200}`,
                padding: "18px 15px 18px 16px",
                width: isDesktopDrawerOpen ? "204px" : "36px",
                transition: "width 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",

                "#tasks": {
                    boxShadow: isTaskGroupsTutorialActive
                        ? `0 0 0 2px ${blue700} `
                        : "",
                    borderRadius: isTaskGroupsTutorialActive ? "8px" : ""
                }
            })}
        >
            <div
                css={css({
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%"
                })}
            >
                <Navigation />

                {!to1099 && (
                    <ToggleDrawerButton
                        isdrawerOpen={isDesktopDrawerOpen}
                        onOpendrawer={() => handleDrawerStatus(true)}
                        onDrawerClose={() => handleDrawerStatus(false)}
                    />
                )}
            </div>
        </aside>
    );
};

export default DesktopDrawer;
